import ApplicationAdapter from 'uplisting-frontend/adapters/application';

export default class AIDraftAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'messaging_ai_drafts';
  }
}

declare module 'ember-data/types/registries/adapter' {
  interface AdapterRegistry {
    'ai-draft': AIDraftAdapter;
  }
}
